import {
  useSnackbar,
  type OptionsObject,
  type VariantType,
  type SnackbarKey,
  type SnackbarMessage,
} from '@dhl/snackbar'

type EnqueueSnackbarFunction = (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey

type NotificationMessage = {
  showSuccess: EnqueueSnackbarFunction
  showError: EnqueueSnackbarFunction
  showWarning: EnqueueSnackbarFunction
  showInformation: EnqueueSnackbarFunction
}

export const useNotificationMessage = (): NotificationMessage => {
  const { enqueueSnackbar } = useSnackbar()

  const show =
    (variant: VariantType) =>
    (message: SnackbarMessage, config: OptionsObject = {}): SnackbarKey =>
      enqueueSnackbar(message, { ...config, variant })

  return {
    showSuccess: show(`success`),
    showError: show(`error`),
    showWarning: show(`warning`),
    showInformation: show(`info`),
  }
}
